module.exports = __webpack_public_path__ + "static/media/svidetelstvo.fbcf0faa.png";